

define(['jquery', 'angular', 'squid/index', './contingencies'], function ($, angular, squid, contingencyList) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('fi.errorUtil', ['squid']).factory('$fiErrorUtil', function ($renderContent) {
        return {
            addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {

                // error handling for filifecycle and fimanagement. 
                if (!errorData.errorCodes) {
                    errorData.errorCodes = errorData && [errorData['0']];
                }

                var messages = [];
                if (errorData.errorCodes && errorData.errorCodes.length) {
                    errorData.errorCodes.forEach(function (errorCode) {
                        var contentKey = contingencyList[errorCode] || defaultKey || 'errorGeneral';
                        var message;
                        if (angular.isArray(contentKey)) {
                            for (var i = 0; i < contentKey.length; i++) {
                                message = $renderContent(contentBundle + '.' + contentKey[i], prop);
                                if (message) {
                                    break;
                                }
                            }
                        } else {
                            message = $renderContent(contentBundle + '.' + contentKey, prop);
                        }

                        messages.push(message);
                    });

                    return {
                        msgs: messages,
                        type: 'error'
                    };
                }
            },

            /**
             * Highlight the Error Fields by ng-model
             * @param errorData
             * @param element
             * @param modelPrefix
             */
            addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {

                if (errorData.fields && errorData.fields.length) {
                    errorData.fields.forEach(function (field) {
                        var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');
                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    });
                }
                $(element).find('.backendError:first').focus();
            },

            /**
             * Highlight the Error Fields by element name
             * @param errorData
             * @param element
             * @param modelPrefix
             */
            addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {

                if (errorData.fields && errorData.fields.length) {
                    errorData.fields.forEach(function (field) {
                        var fieldName = void 0;
                        if (modelPrefix && field.field && field.field.length > 0) {
                            // Add prefix with CamelCase of field name
                            fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
                        } else {
                            fieldName = field.field;
                        }
                        var $field = $(element).find('[name="' + fieldName + '"]');
                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    });
                }
                $(element).find('.backendError:first').focus();
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/fi-contingency-list/util.js
 ** module id = 232
 ** module chunks = 1
 **/